export default class SearchBoxController {
    /** @ngInject */
    constructor(ThingsService, EventEmitter, DialogService, $timeout) {
        this.ThingsService = ThingsService;
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.things = this.ThingsService.getAllThings();
    }

    toggleDropdownPanel() {
        this.dropdownTouched = true;
        this.dropdownVisible = !this.dropdownVisible;
    }

    showDropdownPanel() {
        this.dropdownTouched = true;
        this.dropdownVisible = true;
    }

    hideDropdownPanel() {
        this.dropdownTouched = true;
        this.dropdownVisible = false;
    }

    focused() {
        this.dropdownTouched = true;
        if (!this.query) {
            this.showDropdownPanel();
        }
    }

    blurred() {
        this.dropdownTouched = false;
        this.$timeout(() => {
            if (!this.dropdownTouched) {
                this.hideDropdownPanel();
            }
        }, 200);
    }

    queryChanged() {
        if (this.query) {
            this.hideDropdownPanel();
        } else {
            this.showDropdownPanel();
        }
    }

    search() {
        this.emitSearchEvent(this.query);
    }

    emitSearchEvent(query) {
        this.onSearch(
            this.eventEmitter({
                query
            })
        );
        this.hideDropdownPanel();
    }

    searchByType(type) {
        const query = `type:${type}`;
        this.emitSearchEvent(query);
    }

    searchStarred() {
        const query = 'starred:true';
        this.emitSearchEvent(query);
    }

    clear() {
        this.query = '';
        this.onClear();
    }

}



// WEBPACK FOOTER //
// ./app/common/search-box/search-box.controller.js